export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Body_Roughness.9d37e5c7.tga";